import { useState } from 'react'
import type { ResolvedAvatarOption } from '@/types/join'
import { t } from '@/i18n/translations'

interface Props {
  language: 'de' | 'en'
  avatars: ResolvedAvatarOption[]
  onSelect: (index: number) => void
  onBack?: () => void
}

function AvatarOptionButton({
  avatar,
  language,
  onSelect,
}: {
  avatar: ResolvedAvatarOption
  language: 'de' | 'en'
  onSelect: (index: number) => void
}) {
  const [imgFailed, setImgFailed] = useState(false)
  const showImage = !!avatar.imageUrl && !imgFailed
  const voiceLabel = avatar.label === 'voice:female'
    ? t(language, 'avatarVoiceFemale')
    : avatar.label === 'voice:male'
      ? t(language, 'avatarVoiceMale')
      : null

  return (
    <button
      className={`avatar-btn${voiceLabel ? ' avatar-btn--with-voice-label' : ''}`}
      onClick={() => onSelect(avatar.index)}
    >
      {showImage ? (
        <img
          src={avatar.imageUrl as string}
          alt={voiceLabel ? '' : avatar.label}
          className="avatar-img"
          onError={() => setImgFailed(true)}
        />
      ) : !voiceLabel ? (
        <span className="avatar-label">{avatar.label}</span>
      ) : null}
      {voiceLabel && <span className="avatar-voice-label">{voiceLabel}</span>}
    </button>
  )
}

export function AvatarSelection({ language, avatars, onSelect, onBack }: Props) {
  const title = language === 'de' ? 'Wähle deinen Interviewer' : 'Choose your interviewer'
  const backLabel = language === 'de' ? '← Zurück' : '← Back'
  return (
    <div className="tembo-demo-overlay">
      <div className="tembo-demo-content">
        {onBack && (
          <button className="back-btn" onClick={onBack}>
            {backLabel}
          </button>
        )}
        <img src="/images/logo.png" alt="TEMBO Logo" className="tembo-logo" />
        <div className="avatar-selection-title">{title}</div>
        <div className="avatar-selection-buttons">
          {avatars.map((a) => (
            <AvatarOptionButton key={a.index} avatar={a} language={language} onSelect={onSelect} />
          ))}
        </div>
      </div>
    </div>
  )
}
